const WORDS = ["Sanctuary", "Water", "Light", "Stone", "Warmth", "Ritual", "Calm", "Steam", "A Spaces by Samita Venture"];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {WORDS.map((w) => (
            <span key={w} className="flex items-center">
                <span className="px-6 sm:px-10 font-serif italic font-light text-2xl sm:text-4xl text-white/80">
                    {w}
                </span>
                <span className="h-1.5 w-1.5 rounded-full bg-brass" />
            </span>
        ))}
    </div>
);

const Marquee = () => (
    <div className="relative overflow-hidden border-y hairline-dark bg-noir py-6 sm:py-8" data-testid="editorial-marquee">
        <div className="marquee-track">
            <Row />
            <Row />
        </div>
    </div>
);

export default Marquee;
